import { colors } from '../tokens';

/**
 * Button overrides — preserved exactly from the original monolithic theme.
 * Note: styleOverrides.Standard is not a valid MUI slot; it is kept as-is
 * so behavior remains unchanged (Standard variant buttons only receive root styles).
 */
const MuiButton = {
  styleOverrides: {
    root: {
      textTransform: 'none',
      borderRadius: '8px',
      height: '41px',
      padding: '10px',
      fontWeight: '600',
      '&:hover': {
        boxShadow: 'none',
      },
    },
    Standard: {
      width: 'fit-content',
      border: 'none',
      backgroundColor: colors.primary.main,
      color: colors.primary.contrastText,
      fontSize: '15px',
      fontWeight: 500,
      letterSpacing: 0.3,
      padding: '10px 20px',
      '&:hover': {
        backgroundColor: colors.primary.main,
        border: 'none',
      },
    },
    outlined: {
      width: 'fit-content',
      border: `1px solid ${colors.border.light}`,
      color: colors.neutral.outlinedText,
      fontSize: '15px',
      fontWeight: 500,
      letterSpacing: 0.3,
      '&:hover': {
        backgroundColor: 'none',
      },
    },
  },
};

export default MuiButton;
